import { Injectable, inject, signal } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth';

const AUTO_LOGOUT_SECONDS = 180;

@Injectable({ providedIn: 'root' })
export class OktaMigrationTimerService {
  private readonly authService = inject(AuthService);

  private timer: ReturnType<typeof setInterval> | null = null;

  readonly countdown = signal(AUTO_LOGOUT_SECONDS);

  readonly active = signal(false);

  start(): void {
    if (this.timer !== null) return;

    this.countdown.set(AUTO_LOGOUT_SECONDS);
    this.active.set(true);

    this.timer = setInterval(() => {
      const remaining = this.countdown() - 1;
      this.countdown.set(remaining);

      if (remaining <= 0) {
        this.cancel();
        this.authService.signOut();
      }
    }, 1000);
  }

  cancel(): void {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.active.set(false);
  }

  signOutNow(): void {
    this.cancel();
    this.authService.signOut();
  }
}
